import React, { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import "@fontsource-variable/inter";
import { CssBaseline } from "@mui/material";
import * as Sentry from "@sentry/browser";
import Theme from "./context/theme";
import store from "./store";
import "./index.css";

import App from "./components/App";
import config from "./config";
import { BrowserRouter } from "react-router";

if (config.sentryDSN !== null) {
  Sentry.init({
    dsn: config.sentryDSN,
    environment: config.environment,
  });
}

const rootElement = document.getElementById("root");
const root = createRoot(rootElement);

root.render(
  <StrictMode>
    <Provider store={store}>
      <Theme>
        <CssBaseline />
        <BrowserRouter useTransitions>
          <App />
        </BrowserRouter>
      </Theme>
    </Provider>
  </StrictMode>,
);
